import { Divider } from 'antd'

import { BulletListButton } from './BulletListButton'
import { NumberedListButton } from './NumberedListButton'
import { CheckListButton } from './CheckListButton'
import { ToggleBlockButton } from './ToggleBlockButton'
import { DecreaseIndentButton } from './DecreaseIndentButton'
import { IncreaseIndentButton } from './IncreaseIndentButton'

import Styles from './ListStyleSelection.module.scss'

export const ListStyleSelection = () => {
  return (
    <div className={Styles.listStyleSelection}>
      <BulletListButton />
      <NumberedListButton />
      <CheckListButton />
      <ToggleBlockButton />
      <Divider type="vertical" className={Styles.divider} />
      <DecreaseIndentButton />
      <IncreaseIndentButton />
    </div>
  )
}
